import { cn } from '../../utils/cn';

// KV — label/value pair, e.g. "RUT: 12.345.678-9".
// Used in info cards (CompanyInfoCard, HoldingCompaniesList, ...).
//
// Props:
//   - label: ReactNode
//   - value: ReactNode (renders "—" placeholder when falsy)
//   - mono?: boolean   — apply font-mono to the value (RUTs, ids, etc.)
//   - className?: string

export function KV({ label, value, mono, className }) {
  return (
    <div className={cn('text-sm', className)}>
      <span className="text-fg-muted">{label}: </span>
      <span className={cn('text-fg', mono && 'font-mono')}>{value || '—'}</span>
    </div>
  );
}

KV.displayName = 'KV';

export default KV;
